import packageJson from "../../package.json";
import { getSchedulesVersionParts as getGenerated } from "./buildInfo.generated";

export { SCHEDULES_BUILD_META } from "./buildInfo.generated";

const EM = "\u2014";
const EASTERN_TZ = "America/New_York";

/** Show 1.0.0 as 1.0; other versions unchanged. */
function formatProductVersion(version) {
  const s = String(version || "").trim();
  if (!s) return s;
  const m = s.match(/^(\d+)\.(\d+)\.0$/);
  if (m) return `${m[1]}.${m[2]}`;
  return s;
}

/** Match generated script: YYYY-MM-DD HH:MM EST|EDT */
function formatBuiltEastern(d) {
  const f = new Intl.DateTimeFormat("en-US", {
    timeZone: EASTERN_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZoneName: "short",
  });
  const parts = f.formatToParts(d);
  const g = (type) => parts.find((p) => p.type === type)?.value || "";
  return `${g("year")}-${g("month")}-${g("day")} ${g("hour")}:${g("minute")} ${g("timeZoneName")}`;
}

function formatBuiltForDisplay(raw) {
  const s = String(raw || "").trim();
  if (!s) return s;
  if (/^\d{4}-\d{2}-\d{2}T/.test(s)) {
    const d = new Date(s);
    if (!Number.isNaN(d.getTime())) return formatBuiltEastern(d);
  }
  return s;
}

/** Prefer CI env overrides; otherwise use generated meta from npm prestart/prebuild. */
export function getSchedulesVersionParts() {
  const base = getGenerated();

  const versionRaw = (
    process.env.REACT_APP_BUILD_VERSION ||
    packageJson.version ||
    base.version ||
    ""
  ).trim();

  const commit = (
    process.env.REACT_APP_GIT_COMMIT ||
    process.env.REACT_APP_SOURCE_VERSION ||
    (typeof base.commitFull === "string" && base.commitFull !== EM ? base.commitFull : "")
  ).trim();

  const tag = (
    process.env.REACT_APP_GIT_TAG ||
    (typeof base.tag === "string" && base.tag !== EM ? base.tag : "") ||
    ""
  ).trim();

  const builtRaw = (
    process.env.REACT_APP_BUILD_TIME ||
    base.built ||
    ""
  ).trim();

  const commitFull = commit || base.commitFull || EM;
  const commitPreview =
    commit && commit.length > 14
      ? `${commit.slice(0, 12)}…`
      : commit || base.commitPreview || EM;

  const version = formatProductVersion(versionRaw) || EM;
  const built = formatBuiltForDisplay(builtRaw) || EM;

  return {
    version,
    commitFull,
    commitPreview,
    tag: tag || EM,
    built,
  };
}
